module.exports = __webpack_public_path__ + "img/old_logo_enhanced.f2b19aa8.png";